import { getRangeValue } from '@/packages/JsonQuery';

import { type ITagGroupConfig } from '../types';
import { getRangeText } from '../utils/getRangeText';

export const roomArea: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getRangeValue('room_area')(jsonQuery);
    const rangeText = getRangeText(value);
    if (!rangeText) {
      return null;
    }

    return [
      {
        group: 'roomArea',
        text: `Площадь комнаты ${rangeText} м\u00B2`,
      },
    ];
  },
  delete({ onChange }) {
    onChange(
      {
        action: 'setRoomAreaMin',
        arguments: [null],
      },
      {
        action: 'setRoomAreaMax',
        arguments: [null],
      },
    );
  },
};
